import {
  GetInvoiceProductsIntegrationsResponse,
  GetInvoiceProductsIntegrationsResponseSchema,
} from '@vy/api-definition';
import { IntegrationTypeV3 } from '@vy/integrations-types';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useInvoiceProductsIntegrations(
  invoiceId: string,
  integration: Exclude<IntegrationTypeV3, 'Connact'>,
  options?: CustomUseQueryOptions<GetInvoiceProductsIntegrationsResponse>,
) {
  return useQuery(
    queryKeys.invoiceProductsIntegrations(invoiceId, integration),
    async () => {
      const api = getPrivateApi();
      const getInvoiceProductsIntegrationsResponse = await api.getInvoiceProductsIntegrations({
        invoiceId,
        integration,
      });

      return GetInvoiceProductsIntegrationsResponseSchema.parse(getInvoiceProductsIntegrationsResponse);
    },
    {
      ...options,
    },
  );
}
